export const tokenAddresses = {
  EUL: "0x0000000000000000000000000000000000000000",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0x0000000000000000000000000000000000000000",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
